import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { withOnMountHandler } from "../../../../../../../../utils/withOnMountHandler";
import { ModalWithSelection } from "./ModalWithSelection";
import { getConverter } from "./converter";
var converter = getConverter({
  navigateToUrl: function navigateToUrl(url) {
    /** NOTE: https://stackoverflow.com/a/70463940 */
    setTimeout(function () {
      return window.open(url);
    });
  }
});
export var BanksList = compose(withDataConverter(converter),
//
withOnMountHandler)(ModalWithSelection);